import { NumberField } from '@base-ui/react/number-field';
import type { ComponentPropsWithRef, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export type NumberInputScrubAreaProps = ComponentPropsWithRef<typeof NumberField.ScrubArea> & {
  cursor?: ReactNode;
  cursorClassName?: string;
};

const NumberInputScrubArea = ({
  className,
  children,
  cursor,
  cursorClassName,
  ...props
}: NumberInputScrubAreaProps) => {
  return (
    <NumberField.ScrubArea
      data-slot="number-input-scrub-area"
      className={cn('cursor-ew-resize', className)}
      {...props}
    >
      {children}
      <NumberField.ScrubAreaCursor
        data-slot="number-input-scrub-area-cursor"
        className={cn('drop-shadow-[0_1px_1px_#0008] filter', cursorClassName)}
      >
        {cursor}
      </NumberField.ScrubAreaCursor>
    </NumberField.ScrubArea>
  );
};

NumberInputScrubArea.displayName = 'NumberInputScrubArea';

export default NumberInputScrubArea;
